<template>
  <el-container class="signIn">
    <el-main>
      <div class="container">
        <img
          v-if="isTrialMode"
          src="@/assets/logo1_trial.png"
          alt="ロゴ"
          class="logo"
        />
        <img v-else src="@/assets/logo1.png" alt="ロゴ" class="logo" />

        <el-row class="container__form">
          <el-input placeholder="example@email.com" v-model="email"></el-input>
        </el-row>
        <el-row class="container__form">
          <el-input
            placeholder="******"
            v-model="password"
            type="password"
          ></el-input>
        </el-row>
        <div class="flex center gaps">
          <div class="box version">
            <small v-if="!isProduction">
              バージョン: {{ version }} ({{ mode }})
            </small>
            <small v-else>
              バージョン: {{ version }}
            </small>
          </div>
          <div class="box grow" />
          <div class="box">
            <el-button
              @click="onClickSignIn"
              type="primary"
              :loading="isLoading"
            >
              サインイン
            </el-button>
          </div>
        </div>
        <el-row
          v-if="new Date('2026-09-24T18:00:00+09:00') < new Date() && new Date() < new Date('2026-09-24T18:30:00+09:00')"
          class="container__maintenance"
          style="margin-top: 20px"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>■メンテナンス実施のお知らせ</span>
            </div>
            <div style="font-size: 0.9rem">
              平素より戒名発注アプリnanokosをご利用頂きありがとうございます。<br />誠に勝手ながら、以下の日程でメンテナンスを実施させて頂きます。<br /><br />
              【実施期間】<br />
              2026年09月24日(木)18:00&emsp;～&emsp;2026年09月24日(木)18:30<br /><br />
              メンテナンス中は、全サービスのご利用を停止させて頂きます。<br />
              ご不便をおかけしますが何卒ご理解の程よろしくお願い致します。
            </div>
          </el-card>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Auth from "@/services/auth.service";
const authService = new Auth();

export default {
  components: {},
  mounted () {
  },
  data () {
    return {
      email: "",
      password: "",
      role: "",
      isLoading: false,
      version: process.env.VUE_APP_VERSION,
      mode: process.env.VUE_APP_MODE,
    };
  },
  computed: {
    isProduction: () => {
      return process.env.NODE_ENV === "production";
    },
    isTrialMode: () => {
      return process.env.VUE_APP_MODE === "trial";
    },
  },
  methods: {
    async onClickSignIn () {
      if (
        new Date("2026-09-24T18:00:00+09:00") < new Date() &&
        new Date() < new Date("2026-09-24T18:30:00+09:00")
      ) {
        alert(
          "メンテナンス中のためログインできません。詳しくは「メンテナス実施のお知らせ」をご確認ください。"
        );
        return;
      }
      this.isLoading = true;
      const { email, password } = this;
      const { commit } = this.$store;
      const res = await signIn(email, password);
      if (res) {
        const { name, email, sub } = res.attributes;
        const role = await authService.getCurrentUserRole();
        const isAdmin = await authService.isAdmin();
        commit("user/set", { name, email, sub, role });
        const { $router } = this;
        if (isAdmin) {
          $router.push("/admin/dashboard");
          return;
        }
        $router.push("/home");
        return;
      }
      this.isLoading = false;
      alert("サインインに失敗しました。");
    },
  },
};

/**
 * sign in with email and password
 * @async
 * @param {string} email - The email address
 * @param {string} password - The password
 * @returns {Promise<Object>} Promise object represents the result of authentication
 */
async function signIn (email, password) {
  try {
    return await authService.signIn(email, password);
  } catch (err) {
    return false;
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  width: 40vw;
  height: 40vw;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.logo {
  width: 50%;
  margin: 50px auto;
  display: block;
}
.container__form {
  margin-bottom: 10px;
}
.container__buttons {
  display: flex;
}

.button {
  display: flex;
  flex: 1;
  align-items: flex-end;
}

.button--right {
  justify-content: flex-end;
}

.version {
  text-align: left;
  color: #666;
}

@media (max-width: 1024px) {
  .container {
    position: absolute;
  }
}
</style>
